export const CardSkeleton = () => (
    <div className="border border-theme_clr1 rounded-lg p-4 animate-pulse">
        <div className="h-10 w-10 bg-gray-300 rounded-lg mb-3"></div>
        <div className="h-3 w-24 bg-gray-300 rounded mb-2"></div>
        <div className="h-6 w-16 bg-gray-300 rounded"></div>
    </div>
);

export const ChartSkeleton = () => (
    <div className="h-[350px] bg-gray-200 rounded-xl animate-pulse"></div>
);

export const RowSkeleton = () => (
    <div className="flex items-center justify-between gap-5 animate-pulse">
        <div className="flex items-center gap-2">
            <div className="w-[35px] h-[35px] bg-gray-300 rounded-full"></div>
            <div className="h-4 w-20 bg-gray-300 rounded"></div>
        </div>
        <div className="flex-1 h-[30px] bg-gray-300 rounded-lg"></div>
    </div>
);

export const CustomizeStepSkeleton = () => {
    return (
        <div className="bg-white rounded-lg border-2 border-blue-900 p-6 animate-pulse">
            {/* Title */}
            <div className="mb-6">
                <div className="h-6 w-2/3 bg-gray-200 rounded mb-2" />
                <div className="h-4 w-1/2 bg-gray-200 rounded" />
            </div>

            {/* Input blocks */}
            {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="mb-5">
                    <div className="h-4 w-40 bg-gray-200 rounded mb-2" />
                    <div className="h-10 w-full bg-gray-200 rounded" />
                </div>
            ))}

            {/* Artwork */}
            <div className="mb-6">
                <div className="h-4 w-32 bg-gray-200 rounded mb-3" />
                <div className="flex items-center gap-4">
                    <div className="h-20 w-20 bg-gray-200 rounded" />
                    <div className="h-10 w-32 bg-gray-200 rounded" />
                </div>
            </div>

            <hr className="my-8" />

            {/* Layout buttons */}
            <div className="mb-6">
                <div className="h-4 w-24 bg-gray-200 rounded mb-3" />
                <div className="grid grid-cols-3 gap-3">
                    <div className="h-10 bg-gray-200 rounded" />
                    <div className="h-10 bg-gray-200 rounded" />
                    <div className="h-10 bg-gray-200 rounded" />
                </div>
            </div>

            {/* Background buttons */}
            <div className="mb-6">
                <div className="h-4 w-32 bg-gray-200 rounded mb-3" />
                <div className="grid grid-cols-3 gap-3">
                    <div className="h-10 bg-gray-200 rounded" />
                    <div className="h-10 bg-gray-200 rounded" />
                    <div className="h-10 bg-gray-200 rounded" />
                </div>
            </div>

            {/* URL input */}
            <div>
                <div className="h-4 w-64 bg-gray-200 rounded mb-2" />
                <div className="h-10 w-full bg-gray-200 rounded" />
            </div>
        </div>
    );
};


export const RightPreviewSkeleton = () => {
    return (
        <div className="right-section w-[350px] mx-auto mt-6">
            <div className="animate-pulse border-[10px] border-[#B2B2B2] rounded-[50px] w-[350px] h-[667px] overflow-hidden relative bg-gray-100">

                {/* Notch */}
                <div className="absolute top-2 left-1/2 -translate-x-1/2 w-[100px] h-[30px] bg-gray-300 rounded-full" />

                <div className="px-4 pt-[52px] pb-4 flex flex-col gap-4">

                    {/* Image */}
                    <div className="h-[280px] rounded-lg bg-gray-300" />

                    {/* Track card */}
                    <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-4">
                        <div className="flex items-center gap-3">
                            <div className="h-10 w-10 rounded-full bg-gray-300" />
                            <div className="flex-1">
                                <div className="h-4 w-3/4 bg-gray-300 mb-2 rounded" />
                                <div className="h-3 w-1/2 bg-gray-300 rounded" />
                            </div>
                            <div className="h-6 w-6 bg-gray-300 rounded" />
                        </div>
                    </div>

                    {/* Social icons */}
                    <div className="flex justify-center gap-4 mt-2">
                        {Array.from({ length: 4 }).map((_, i) => (
                            <div key={i} className="h-6 w-6 bg-gray-300 rounded-full" />
                        ))}
                    </div>

                    {/* Store buttons */}
                    <div className="grid grid-cols-2 gap-3 mt-3">
                        {Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} className="h-[60px] bg-gray-300 rounded-lg" />
                        ))}
                    </div>

                </div>
            </div>
        </div>
    );
};

export const SkeletonBox = ({ className = "" }) => (
  <div className={`animate-pulse bg-gray-200 rounded-md ${className}`} />
);

export const OverallAnalyticsCardSkeleton = () => (
  <div className="border-[5px] border-theme_clr1 rounded-lg p-4">
    <SkeletonBox className="h-10 w-10 mb-3" />
    <SkeletonBox className="h-4 w-28 mb-2" />
    <SkeletonBox className="h-7 w-24" />
  </div>
);

export const AudienceTableSkeleton = ({ rows = 5 }) => {
  return (
    <div className="w-full min-h-[300px] px-4 py-6">
      <div className="space-y-4 animate-pulse">
        {Array.from({ length: rows }).map((_, i) => (
          <div
            key={i}
            className="grid grid-cols-5 gap-4 items-center"
          >
            {/* Email / Profile */}
            <div className="flex items-center gap-3 col-span-2">
              <div className="w-6 h-6 rounded-full bg-gray-200" />
              <div className="flex flex-col gap-2 w-full">
                <div className="h-3 w-3/4 bg-gray-200 rounded" />
              </div>
            </div>

            {/* Other columns */}
            <div className="h-3 w-24 bg-gray-200 rounded" />
            <div className="h-3 w-20 bg-gray-200 rounded" />
            <div className="h-3 w-20 bg-gray-200 rounded" />
            <div className="h-3 w-16 bg-gray-200 rounded" />
          </div>
        ))}
      </div>
    </div>
  );
};

export const BioLinkSkeleton = () => {
    return (
        <div className="animate-pulse space-y-6">

            {/* IMAGE CARD */}
            <div className="bg-white p-6 rounded-xl space-y-4">
                <div className="h-4 w-40 bg-gray-300 rounded"></div>
                <div className="h-3 w-60 bg-gray-200 rounded"></div>

                <div className="flex items-center justify-between border rounded-xl p-4">
                    <div className="flex items-center gap-3">
                        <div className="w-[70px] h-[70px] bg-gray-300 rounded-xl"></div>
                        <div className="h-4 w-24 bg-gray-300 rounded"></div>
                    </div>
                    <div className="h-4 w-16 bg-gray-300 rounded"></div>
                </div>

                <div className="space-y-3">
                    <div className="h-10 bg-gray-200 rounded"></div>
                    <div className="h-10 bg-gray-200 rounded"></div>
                </div>
            </div>

            {/* FAN ACTION */}
            <div className="bg-white p-6 rounded-xl space-y-3">
                <div className="h-5 w-40 bg-gray-300 rounded"></div>
                <div className="h-10 bg-gray-200 rounded"></div>
                <div className="h-10 bg-gray-200 rounded"></div>
            </div>

            {/* STREAMING */}
            <div className="bg-white p-6 rounded-xl space-y-4">
                <div className="h-5 w-40 bg-gray-300 rounded"></div>
                <div className="flex gap-2">
                    <div className="h-10 w-24 bg-gray-200 rounded-full"></div>
                    <div className="h-10 w-24 bg-gray-200 rounded-full"></div>
                    <div className="h-10 w-24 bg-gray-200 rounded-full"></div>
                </div>
            </div>

            {/* SOCIAL */}
            <div className="bg-white p-6 rounded-xl space-y-3">
                <div className="h-5 w-40 bg-gray-300 rounded"></div>
                <div className="h-10 bg-gray-200 rounded"></div>
            </div>

        </div>
    );
};